<template>
  <div>
    <div class="ml-2 mt-12 text-h5">アカウント管理</div>
    <div class="ml-4 blue-grey--text">赤印のある項目は必須入力です</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="4">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col>
          <v-text-field
            v-if="input.key == 'company'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.company.$model"
            :error-messages="companyErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'postal-code'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.postalCode.$model"
            :error-messages="postalCodeErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'address'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.address.$model"
            :error-messages="addressErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'name'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.name.$model"
            :error-messages="nameErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'kana'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.kana.$model"
            :error-messages="kanaErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'phone-number'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.phoneNumber.$model"
            :error-messages="phoneNumberErrorMessage"
            :error-count="3"
          ></v-text-field>
          <v-text-field
            v-if="input.key == 'mail-address'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.mailAddress.$model"
            :error-messages="mailAddressErrorMessage"
            :error-count="3"
          ></v-text-field>
          <div v-if="input.key == 'mail-address.fixed'" class="mt-2 mb-2 ml-3">
            {{ formData.mailAddress }}
          </div>
          <append-two-column-select-list
            v-if="input.key == 'join'"
            ref="joinSelect"
            :contents="joinPermission"
            :roles="joinRoles"
            :min="1"
            :appendable="true"
          ></append-two-column-select-list>
          <append-two-column-select-list
            v-if="input.key == 'permissions'"
            ref="permissionSelect"
            :contents="permission"
            :roles="permissionRoles"
            :min="0"
            :appendable="true"
          ></append-two-column-select-list>
          <div v-if="input.key == 'superuser'">
            <v-checkbox
              v-model="formData.systemUserFlag"
              label="システム管理者として登録する"
            ></v-checkbox>
          </div>
          <div v-if="input.key == 'superuser.fixed'">
            <div v-if="formData.systemUserFlag" class="ml-3 green--text">
              <v-icon>mdi-check</v-icon>システム管理者
            </div>
            <div v-else class="ml-3 grey--text">-</div>
          </div>
          <div v-if="input.key == 'producer'">
            <v-checkbox
              v-model="formData.producerFlag"
              label="生産者"
            ></v-checkbox>
          </div>
          <div v-if="input.key == 'information_admin'">
            <v-checkbox
                v-model="formData.informationAdminFlag"
                label="お知らせ編集権限"
            ></v-checkbox>
          </div>
          <div v-if="input.key == 'csv_permission'">
            <v-checkbox
                v-model="formData.csvPermission"
                label="CSV出力権限"
            ></v-checkbox>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            class="ma-2"
            width="200"
            @click="register"
            :disabled="!view_status.editable"
            >登録</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AppendTwoColumnSelectList from "../components/common/append-two-column-select-list.vue";
import Api from "@/logic/api/api.js";
import Roles from "@/logic/common/roles.js";
import Validate from "@/logic/common/validate.js";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import { required, maxLength } from "vuelidate/lib/validators";
import valueMapper from "../logic/common/value-mapper";
import ValueConverer from "../logic/common/value-converter";

export default {
  components: {
    "append-two-column-select-list": AppendTwoColumnSelectList,
    alert: Alert,
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 企業名
      company: {
        maxLength: maxLength(64),
      },
      // 郵便番号
      postalCode: {
        maxLength: maxLength(16),
        postalCode: Validate.rule.postalCode,
      },
      // 住所
      address: {
        maxLength: maxLength(128),
      },
      // 氏名
      name: {
        required,
        maxLength: maxLength(64),
      },
      // 氏名（かな）
      kana: {
        maxLength: maxLength(64),
      },
      // 電話番号
      phoneNumber: {
        maxLength: maxLength(32),
        phoneNumber: Validate.rule.phoneNumber,
      },
      // メールアドレス
      mailAddress: {
        required,
        email: Validate.rule.email,
        halfCharacter: Validate.rule.halfCharacter,
        maxLength: maxLength(128),
      },
    },
  },
  computed: {
    /**
     * 登録ボタンが有効ならtrueを返す
     */
    disableRegisterButton() {
      return Validate.hasError([
        this.$v.formData.mailAddress,
        this.$v.formData.phoneNumber,
        this.$v.formData.name,
        this.$v.formData.kana,
        this.$v.formData.company,
        this.$v.formData.postalCode,
        this.$v.formData.address,
      ]);
    },
    /**
     * エラーメッセージ：企業名
     */
    companyErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.company,
        "企業名",
        ["maxLength"]
      );
    },
    /**
     * エラーメッセージ：企業名
     */
    postalCodeErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.postalCode,
        "郵便番号",
        ["maxLength", "postalCode"]
      );
    },
    /**
     * エラーメッセージ：住所
     */
    addressErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.address,
        "住所",
        ["maxLength"]
      );
    },
    /**
     * エラーメッセージ：氏名
     */
    nameErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.name,
        "氏名",
        ["required", "maxLength"],
        !this.delayCheck
      );
    },
    /**
     * エラーメッセージ：氏名（かな）
     */
    kanaErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.kana,
        "氏名（かな）",
        ["maxLength"]
      );
    },
    /**
     * エラーメッセージ：電話番号
     */
    phoneNumberErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.phoneNumber,
        "電話番号",
        ["maxLength", "phoneNumber"]
      );
    },
    /**
     * エラーメッセージ：メールアドレス
     */
    mailAddressErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.mailAddress,
        "メールアドレス",
        [
          "required",
          "maxLength",
          "halfCharacter",
          { value: "email", condition: this.delayCheck },
        ],
        !this.delayCheck
      );
    },
  },
  data() {
    // ログインユーザーの所属グループ管理者情報を取得する
    const userJoinPermissions = this.$store.getters.userJoinPermissions;

    // URLから対象のユーザー情報を取得する
    const uid = this.$route.params.uid;
    const isCreate = uid == "create" ? true : false;

    // ログインユーザーが広島県の管理者かどうか
    const rootAdmin = userJoinPermissions.some(permission => permission.owner.group_id === "root" && permission.role === 1);

    // 画面に表示する入力欄を定義する
    let inputs = [];
    // 氏名
    inputs.push({
      key: "name",
      title: "氏名",
      required,
    });
    // 氏名（かな）
    inputs.push({
      key: "kana",
      title: "氏名(かな)",
    });
    // メールアドレス
    inputs.push({
      key: "mail-address",
      title: "メールアドレス",
      required,
    });
    // 企業名
    inputs.push({
      key: "company",
      title: "企業名",
    });
    // 郵便番号
    inputs.push({
      key: "postal-code",
      title: "郵便番号",
    });
    // 住所
    inputs.push({
      key: "address",
      title: "住所",
    });
    // 電話番号
    inputs.push({
      key: "phone-number",
      title: "電話番号",
    });
    // システム権限
    // 条件：システム管理者であること
    if (this.$store.getters.isSystemAdmin) {
      if (isCreate) {
        inputs.push({
          key: "superuser",
          title: "システム権限",
        });
      } else {
        inputs.push({
          key: "superuser.fixed",
          title: "システム権限",
        });
      }
    }
    // 生産者
    // 条件：所属グループ管理者であること（先頭グループで判定）
    if (Roles.isAdmin(userJoinPermissions[0].role)) {
      inputs.push({
        key: "producer",
        title: "生産者",
      });
    }
    // お知らせ編集権限
    // 表示条件：広島県の管理者であること
    if (rootAdmin) {
      inputs.push({
        key: "information_admin",
        title: "お知らせ編集権限",
      });
    }
    // CSV出力権限
    // 表示条件：広島県の管理者であること
    if (rootAdmin) {
      inputs.push({
        key: "csv_permission",
        title: "CSV出力権限",
      });
    }
    // 所属グループ
    inputs.push({
      key: "join",
      title: "所属グループ",
      required,
    });
    // グループ権限
    inputs.push({
      key: "permissions",
      title: "グループ権限",
    });

    this.$nextTick(() => {
      this.loadData(uid, isCreate);
    });

    return {
      view_status: {
        editable: false,
      },
      user_id: uid,
      isCreate: isCreate,
      permission: [
        {
          text: "-",
          value: null,
        },
      ],
      joinPermission: [
        {
          text: "-",
          value: null,
        },
      ],
      joinRoles: Roles.joinRoles(),
      permissionRoles: Roles.permissionRoles(),
      inputs: inputs,
      formData: {
        company: "",
        postalCode: "",
        address: "",
        name: "",
        kana: "",
        phoneNumber: "",
        mailAddress: "",
        systemUserFlag: false,
        producerFlag: true,
        informationAdminFlag: true,
        csvPermission: true,
      },
      updateData: {
        recordDate: "",
        permissionIds: [],
      },
      delayCheck: false,
      errors: [],
    };
  },
  methods: {
    loadData(uid, isCreate) {
      // APIの実行中は画面を編集不可にする
      this.view_status.editable = false;
      this.$store.commit("setWaiting", true);
      // ユーザー情報を取得する
      this.$nextTick(() => {
        // ユーザー情報を画面に表示する
        const displayUserData = (user) => {
          this.formData.company = user.company_name;
          this.formData.postalCode = user.postal_code;
          this.formData.address = user.company_address;
          this.formData.name = user.display_name;
          this.formData.kana = user.yomi;
          this.formData.phoneNumber = user.phone_number;
          this.formData.mailAddress = user.email;
          this.formData.systemUserFlag = user.flag_system_admin;
          this.formData.producerFlag = user.flag_producer;
          this.formData.informationAdminFlag = user.flag_information_admin;
          this.formData.csvPermission = user.csv_permission;
          // 編集者に管理権限のない所属グループを表示する
          this.$refs.joinSelect[0].setFixedContents(
            Roles.convertPermissionData(
              user.permissions,
              this.joinPermission,
              (permission) => permission.type == "join",
              false,
              (is_group) => !is_group,
              "owner"
            )
          );
          // 編集者に管理権限のある所属グループを表示する
          this.$refs.joinSelect[0].setSelected(
            Roles.convertPermissionData(
              user.permissions,
              this.joinPermission,
              (permission) => permission.type == "join",
              true,
              (is_group) => !is_group,
              "owner"
            )
          );
          // 編集者に管理権限のないグループ権限を表示する
          this.$refs.permissionSelect[0].setFixedContents(
            Roles.convertPermissionData(
              user.permissions,
              this.permission,
              (permission) => permission.type == "permission",
              false,
              (is_group) => !is_group
            )
          );
          // 編集者に管理権限のあるグループ権限を表示する
          this.$refs.permissionSelect[0].setSelected(
            Roles.convertPermissionData(
              user.permissions,
              this.permission,
              (permission) => permission.type == "permission",
              true,
              (is_group) => !is_group
            )
          );
          // 編集前の権限情報を保持する
          this.updateData.permissionIds = user.permissions;
          // 更新情報を保持する
          this.updateData.recordDate = user.update_date;
        };
        // 参加グループを表示する
        const displayGroupData = () => {
          this.$refs.joinSelect[0].setSelected([
            {
              name: this.joinPermission[0],
              role: this.joinRoles[0],
            },
          ]);
        };
        const mapping = [];
        const requests = [];

        // 新規追加でなければ、ユーザー情報を読み込む
        if (!isCreate) {
          mapping.push("user");
          requests.push(
            Api.call("/admin/user", {
              purpose: "USER_DETAIL",
              user_id: uid,
            })
          );
        }

        // 参加グループとして選択可能なグループ一覧を取得する
        mapping.push("group");
        requests.push(
          Api.call("/admin/group", {
            purpose: "GROUP_MANAGEMENT",
            no_detail: true,
          })
        );

        // 権限付与可能なグループとして選択可能なグループ一覧を取得する
        mapping.push("group.tree");
        requests.push(
          Api.call("/admin/group", {
            purpose: "GROUP_TREE",
            no_detail: true,
          })
        );

        Promise.all(requests)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            if (mapping.includes("group")) {
              // 所属グループ候補を読み込む
              this.joinPermission = ValueConverer.groupForSelectbox(
                result[mapping.indexOf("group")].group_list,
                this.$store.getters.userGroupIds
              );
            }
            if (mapping.includes("group.tree")) {
              // グループ権限候補を読み込む
              this.permission = ValueConverer.groupForSelectbox(
                result[mapping.indexOf("group.tree")].group_list,
                this.$store.getters.userGroupIds
              );
            }
            if (mapping.includes("group") && mapping.includes("group.tree")) {
              displayGroupData();
            }
            if (mapping.includes("user")) {
              displayUserData(result[mapping.indexOf("user")].users[0]);
            }
            // 画面を編集可能にする
            this.view_status.editable = true;
          })
          .catch((result) => {
            // エラーになったリクエストが一つでもあればここに入る
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(result.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(result);
            } else {
              this.showMessage(message);
            }
          });
      });
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * エラーメッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 送信データの共通部分を画面から取得する
     */
    buildCommonData() {
      // 必須でないパラメータをキーから除外する
      const optional = (value) => {
        if (value && value.length >= 1) {
          return value;
        }
        return undefined;
      };
      return {
        phone_number: optional(this.formData.phoneNumber),
        display_name: this.formData.name,
        yomi: optional(this.formData.kana),
        company_name: optional(this.formData.company),
        postal_code: optional(this.formData.postalCode),
        company_address: optional(this.formData.address),
      };
    },
    /**
     * 登録用送信データを画面から取得する
     */
    buildRegisterData() {
      // 権限の一覧を取得する
      let permissions = [];
      [
        // 参加グループの権限を取得する
        {
          target: this.$refs.joinSelect[0],
          type: "join",
          mapping: (group_id) => {
            /**
             ownerとdestinationに指定するID 
            【joinの場合】
             権限所有者：所属するグループ
             操作対象者：個人グループ
            */
            return {
              owner_id: group_id,
              destination_id: "$SELF",
            };
          },
        },
        // グループ参照権限を取得する
        {
          target: this.$refs.permissionSelect[0],
          type: "permission",
          mapping: (group_id) => {
            /**
             ownerとdestinationに指定するID 
            【permissionの場合】
             権限所有者：権限を付与されたグループ
             操作対象者：操作するグループ
            */
            return {
              owner_id: "$SELF",
              destination_id: group_id,
            };
          },
        },
      ].forEach((info) => {
        // 条件に一致する権限を1つの配列にまとめる
        permissions.push(
          ...info.target.getAllContents().map((item) => {
            return {
              ...item.role.value,
              ...info.mapping(item.name.value),
              type: info.type,
            };
          })
        );
      });
      return {
        ...this.buildCommonData(),
        permissions: permissions,
        email: this.formData.mailAddress,
        flag_system_admin: this.formData.systemUserFlag,
        flag_producer: this.formData.producerFlag,
        flag_information_admin: this.formData.informationAdminFlag,
        csv_permission: this.formData.csvPermission,
      };
    },
    /**
     * 更新用登録データを画面から取得する
     */
    buildUpdateData() {
      // 権限の一覧を取得する
      let permissions = [];
      [
        // 参加グループを取得する
        {
          target: this.$refs.joinSelect[0],
          type: "join",
          mapping: (group_id) => {
            return {
              owner_id: group_id,
              destination_id: "$SELF",
            };
          },
        },
        // グループ参照権限を取得する
        {
          target: this.$refs.permissionSelect[0],
          type: "permission",
          mapping: (group_id) => {
            return {
              owner_id: "$SELF",
              destination_id: group_id,
            };
          },
        },
      ].forEach((info) => {
        // 条件に一致する権限を1つの配列にまとめる
        permissions.push(
          ...info.target.getAllContents().map((item) => {
            let result = {
              ...item.role.value,
              ...info.mapping(item.name.value),
              type: info.type,
              is_update: item.meta.edit,
            };
            // 権限IDがあればリクエストパラメータに含める
            if (item.meta.permission_id) {
              result["permission_id"] = item.meta.permission_id;
            }
            return result;
          })
        );
      });
      return {
        ...this.buildCommonData(),
        uid: this.user_id,
        permissions: permissions,
        email: this.formData.mailAddress,
        original_permission_ids: this.updateData.permissionIds.map((item) => {
          return {
            permission_id: item.permission_id,
          };
        }),
        update_date: this.updateData.recordDate,
        flag_producer: this.formData.producerFlag,
        flag_information_admin: this.formData.informationAdminFlag,
        csv_permission: this.formData.csvPermission ? 1 : 0,
      };
    },
    register() {
      this.delayCheck = true;
      this.clearMessage();
      if (this.disableRegisterButton) {
        this.showMessage(AlertBuilder.error("入力した項目が不正です"));
        return;
      }
      if (this.$refs.joinSelect[0].hasError()) {
        this.showMessage(AlertBuilder.error("所属グループに重複があります"));
        return;
      }
      if (this.$refs.permissionSelect[0].hasError()) {
        this.showMessage(AlertBuilder.error("グループ権限に重複があります"));
        return;
      }
      let updateUrl = "";
      let postData = null;
      if (this.isCreate) {
        updateUrl = "/admin/user/create";
        postData = this.buildRegisterData();
        postData.sea_area = 0;
        postData.device_id = "3362,3362,3362";
      } else {
        updateUrl = "/admin/user/update";
        postData = this.buildUpdateData();
        postData.sea_area = this.$store.getters.seaArea;
        postData.device_id = this.$store.getters.deviceId;
      }
      this.$store.commit("setWaiting", true);
      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/account");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/account");
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
